import React from 'react';
import { Link } from 'react-router-dom';

import useThemeController from 'hooks/theme/useThemeController';

export default function Forbidden() {
  useThemeController({ anyRoute: true });

  return (
    <div className="p-5">
      <h1>Acesso negado</h1>
      <p>Desculpe, sua sessão expirou, por favor tente novamente.</p>
      <Link to="/home" className="text-body">
        Voltar para a home
      </Link>
    </div>
  );
}
